export default {
  lucky: {
    prizeAgain: 'Putar Lagi',
    prizeThanks: 'Semoga Beruntung Lain Kali',
    remainingChance: 'Sisa Putaran',
    task: 'Tugas',
    deposit: 'Deposit',
    wager: 'Taruhan',
    noChance: 'No spins available',
    drawFailed: 'Draw failed, please try again',
    prizeWin: 'Congratulations! You won {amount}',
    prizeAgainMsg: 'You got a free spin!',
  },
  card: {
    title: 'Koleksi Kartu',
    puzzleRound: 'Putaran {current}/{total}',
    puzzleReward: 'Hadiah penyelesaian {amount}',
    redeem: 'Tukar',
    redeemSuccess: 'Berhasil ditukar',
    redeemSuccessWithReward: 'Berhasil ditukar! Anda mendapatkan {amount} {currency}',
    redeemFailed: 'Gagal menukar',
    notComplete: 'Belum lengkap, tidak dapat ditukar',
    drawFailed: 'Undian gagal, silakan coba lagi',
    gainLetter: 'Selamat! Anda mendapatkan huruf {letter}',
    gainBlock: 'Selamat! Anda mendapatkan gambar {blockNo}',
    letterReward: '{redeemed}/{limit} · reward {amount}',
  },
  treasureChest: {
    invite: 'Undang',
    claimReward: 'Klaim',
    noChest: 'Tidak ada peti',
    claimSuccess: 'Mengklaim {count} peti, {amount} {currency}',
    modalTitle: 'Peti harta',
    modalSubtitle: 'Geser untuk melihat semua',
    chipTodayClaimed: 'Diklaim hari ini',
    chipClaimable: 'Bisa diklaim',
    chipLocked: 'Terkunci',
    totalClaimedCount: 'Total peti diklaim',
    totalClaimedAmount: 'Total nilai diklaim',
    chestUnit: 'pcs',
    claimAll: 'Klaim semua',
    goInvite: 'Undang Sekarang',
    claimSingleSuccess: 'Diklaim {amount} {currency}',
    labelClaimed: 'Diklaim',
    labelClaimable: 'Bisa diklaim',
    labelLocked: 'Terkunci',
  },
}
